import { REQUEST, SUCCESS, ERROR, ROOT } from './types'

const state = {
  data: {
    returns: [],
    analysis: [],
  },
  loading: false,
  error: false,
}

const getters = {
  analysis: (state) => state.data.analysis,
  returns: (state) => state.data.returns,
}

const actions = {
  async handleReturns(context, { search, page = 1 }) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `riskManager`,
          action: `getReturns`,
          query: `?page=${page}&per_page=${4}&search=${search || ``}`,
        },
        ROOT
      )

      if (response.status !== 200) throw response

      context.commit(SUCCESS, { key: `returns`, data: response.data })

      return
    } catch (error) {
      console.error(error)

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message:
            error.data?.error ||
            error.data?.errors ||
            `Erro, não foi possível buscar os retornos do GR.`,
          color: `secondary`,
        },
        ROOT
      )

      context.commit(ERROR)

      return
    }
  },

  async handleAnalysis(context) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `riskManager`,
          action: `getAnalysis`,
          query: ``,
        },
        ROOT
      )

      if (response.status !== 200) throw response

      context.commit(SUCCESS, { key: `analysis`, data: response.data })

      return
    } catch (error) {
      console.error(error)

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message:
            error.data?.error ||
            error.data?.errors ||
            `Erro, não foi possível buscar as análises do GR.`,
          color: `secondary`,
        },
        ROOT
      )

      context.commit(ERROR)

      return
    }
  },
}

const mutations = {
  [REQUEST](state) {
    state.loading = true
  },
  [SUCCESS](state, payload) {
    state.data[payload.key] = payload.data
    state.loading = false
    state.error = false
  },
  [ERROR]() {
    state.error = true
    state.loading = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
